










export default {
    props: {
        description: {
            type: String,
        },
        descriptionLink: {
            type: Object,
            required: false,
        },
        inputLength: {
            type: Number,
            required: true,
        },
        maxLength: {
            type: Number,
            required: true,
        },
    },
};
